<script setup lang="ts">
import LeStar from "@dsk/icons/LeStar.vue";
import LeStarOutline from "@dsk/icons/LeStarOutline.vue";
import { useI18n } from "vue-i18n";

interface Props {
  isFavorite?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isFavorite: false
});

const emit = defineEmits<{
  favorite: [];
  unfavorite: [];
}>();

const { t } = useI18n();
</script>

<template>
  <button
    type="button"
    class="le-favorite-toggle"
    :aria-label="props.isFavorite ? t('le-dictionary-favorite-toggle.remove') : t('le-dictionary-favorite-toggle.add')"
    @click="props.isFavorite ? emit('unfavorite') : emit('favorite')"
  >
    <span class="le-favorite-toggle__content">
      <Component :is="props.isFavorite ? LeStar : LeStarOutline" class="le-favorite-toggle__icon" role="presentation" />
    </span>
  </button>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-favorite-toggle {
  margin: 0;
  padding: 4px;
  transition: all 75ms ease-out;
  border: 0;
  border-radius: 50%;
  background: none;
  color: @colors[@secondary][800];

  &:hover {
    color: @colors[@secondary][900];
  }

  &.focus-visible {
    .focus-outline(grey);
  }

  &__content {
    display: grid;
    place-items: center;
  }
}
</style>
